module.exports = __webpack_public_path__ + "img/lnk-clients.4a423c3f.svg";